// extracted by mini-css-extract-plugin
export default {"label":"Label__label--3G9","readOnly":"Label__readOnly--3Ok","hint":"Label__hint--2S0","fieldLabelAsterisk":"Label__fieldLabelAsterisk--2VL","tooltipIcon":"Label__tooltipIcon--3yj"};